module.exports = __webpack_public_path__ + "data/unstar.json";


//////////////////
// WEBPACK FOOTER
// ./app/common/thing-star/unstar.json
// module id = jY6q
// module chunks = 1